import { render, staticRenderFns } from "./Experimente.vue?vue&type=template&id=749df137"
import script from "./Experimente.vue?vue&type=script&lang=js"
export * from "./Experimente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('749df137')) {
      api.createRecord('749df137', component.options)
    } else {
      api.reload('749df137', component.options)
    }
    module.hot.accept("./Experimente.vue?vue&type=template&id=749df137", function () {
      api.rerender('749df137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sobre/experimente/Experimente.vue"
export default component.exports